// extracted by mini-css-extract-plugin
export default {"recos":"P5-z","productCardOverride":"Q5-z","rowHasBadge":"R5-z"};